<template lang="pug">
div.avatar
  v-avatar(v-if="imgUrl"  :image='imgUrl')
  v-avatar(v-else)
    strong(:class="{'opened': isOver}").initials 
      span.firstname {{ practitioner?.firstName?.[0] }}
      span.lastname {{ practitioner?.lastName?.[0] }}
    v-menu.menu(activator="parent" z-index="2004" location="end" :close-on-content-click="false")
      v-card.card
        .info
          PractitionersTag(v-if="practitioner" :id="practitioner.id || null")
          v-label.ins-info RPPS: {{insRpps}}
        //- .qr.mb-2
        //-   .place-holder
        //-     v-btn.logoutBtn(color="white" @click="generateQRCode()" variant="flat")
        //-       v-label Voir mon QR Code
        //-   .code(ref="qrcode")
        .change-psw-action
          v-btn.elevation-0.change-psw-btn(color="primary" @click="openTokenExpire()" :class="{'opened': isOver}").checkmark
            v-icon mdi-lock-outline
            v-label Changer votre mot de passe
        .logout-action
          v-btn.logoutBtn(color="primary" @click="openConfirmation()" :class="{'opened': isOver}").checkmark
            v-icon mdi-logout
            v-label Déconnexion


Dialog(
  :showDialog="logoutAlert"
  :preventDialogClose="true"
  type="primary"
  saveButtonText="Me déconnecter"
  closeButtonText="Annuler"
  :description="'Êtes-vous sûr.e de vouloir vous déconnecter ? Vous perdrez tous vos patients en création.'"
  @on:save="logout"
  @on:close="close"
)
</template>
<script setup lang="ts">
import type { Practitioner } from '~/repository/types/practitioner/practitioner'

const { $api: api, $toast: toast } = useNuxtApp()
const imgUrl: Ref<string> = ref('')
const practitioner = ref<Practitioner>()
const userStore = useUserStore()
const navigationStore = useNavigationStore()
const insRpps = ref('')
const qrcode = ref(null)
const isOver: Ref<boolean> = ref(false)
const logoutAlert = ref<boolean>(false)
import QRCodeStyling from 'qr-code-styling'

watch(
  () => userStore.practitioner,
  async (value) => {
    if (value) {
      try {
        practitioner.value = value
        insRpps.value =
          practitioner.value?.identifiers?.filter((e: any) => e?.code.toLowerCase() === 'rpps')?.pop()?.value || '-'
      } catch (error) {
        practitioner.value = { firstName: 'John', lastName: 'Doe' }
      }
    }
  },
  { immediate: true, deep: true },
)

const { signOut, auth, sentResetPasswordLink } = useAuth()
const close = () => {
  logoutAlert.value = false
}

const openConfirmation = () => {
  logoutAlert.value = true
}
async function generateQRCode() {
  await displayQRcode()
}

const openTokenExpire = async () => {
  if (auth.currentUser?.email) {
    await sentResetPasswordLink(auth.currentUser.email)
    toast.success('Vous recevrez rapidement un Email vous permettant de mettre à jour votre mot de passe.', {
      position: 'bottom-right',
      timeout: 5000,
    })
  }
}
async function displayQRcode() {
  try {
    // Call the API to generate OTP
    const otpResult = await api.auth.generateTOTP(practitioner.value.id)

    // Pass the OTP data to the dialog using the exposed method
    const node = qrcode.value
    while (node?.firstChild) {
      node.removeChild(node.firstChild)
    }
    const options = {
      type: 'canvas',
      shape: 'square',
      width: 184,
      height: 184,
      data: 'epoca://login-with-otp?otp=' + otpResult.totp,
      margin: 0,
      qrOptions: { typeNumber: '0', mode: 'Byte', errorCorrectionLevel: 'Q' },
      imageOptions: { saveAsBlob: true, hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
      dotsOptions: { type: 'dots', color: '#31d8b0', roundSize: true },
      backgroundOptions: { round: 0, color: '#ffffff' },
      image: '/images/logo-epoca.svg',
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: '#6a1a4c', color2: '#6a1a4c', rotation: '0' },
      },
      cornersSquareOptions: { type: 'dot', color: '#95fa8b' },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: '#000000', color2: '#000000', rotation: '0' },
      },
      cornersDotOptions: { type: 'dot', color: '#98ff8d' },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: '#000000', color2: '#000000', rotation: '0' },
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: '#ffffff', color2: '#ffffff', rotation: '0' },
      },
    }

    const QRcode = new QRCodeStyling(options)
    console.log(node)
    QRcode.append(node)
  } catch (error) {
    throw error
  }
}

async function logout() {
  // await api.auth.logoutPractitioner(userStore.uid as string, deviceID() as string)
  await api.auth.deleteSession()
  navigationStore.$reset()
  userStore.$reset()

  await signOut()

  logoutAlert.value = false
}
function onOver() {
  isOver.value = true
}
function onOut() {
  isOver.value = false
}

watch(
  () => userStore.isUserLoged,
  (newValue, oldValue) => {
    if (newValue === false) {
      navigateTo('/')
    }
  },
)
</script>

<style lang="stylus" scoped>
:deep().card
  width 230px
  display flex
  flex-direction column
  align-items center
  justify-content center
  .info
    padding-bottom 10px
    padding 15px
    width 100%
    display flex
    justify-content center
    flex-direction column
    gap 5px
    align-items flex-start
    .ins-info
      opacity 1
      font-size var(--fs-12)
  .change-psw-action
    border-top 1px solid #ccc
    border-bottom 1px solid #ccc
    width 100%
    padding 5px 0px
    .change-psw-btn
      width 100%
      height 30px
      background-color #fff !important
      color #070E12 !important;
      cursor pointer
      .v-label
        cursor pointer
        opacity 1
        font-weight 400
        font-size var(--fs-13)
        text-transform none
  .logout-action
    width 100%
    padding 15px
    .logoutBtn
      width 100%
      cursor pointer
      .v-label
        cursor pointer
        opacity 1
        font-size var(--fs-13)
        font-weight 500
        text-transform none
.avatar
  position relative
  cursor pointer
  .checkmark
    bottom: 8px
    position: absolute
    right: 8px
    opacity 0
    transition all .35s ease-in-out 0.1s
    transform: scale(1.3, 1.3)
    transform-origin: center center
    &.opened
      opacity 1
      transform: scale(1, 1)
  .v-avatar
    background-color var(--cultured)
    border 2px solid var(--white, #FFFFFF)
    height 48px
    width 48px
  .initials
    clip-path: circle(24px at center);
    text-transform uppercase
    color var(--black, black)
    font-size 1rem
    font-weight 600

    &.opened
      .firstname
        position relative
        transition all .35s ease-in-out
        transform: translateX(-30px);
        display inline-block
      .lastname
        position relative
        transition all .35s ease-in-out
        transform: translateX(30px);
        display inline-block

.qr
  position relative
  width 184px
  height 184px
  .code
    position absolute
    z-index 2
  .place-holder
    position absolute
    height 184px
    width  184px
    display flex
    align-items center
    justify-content center
    text-align center
    cursor pointer
    padding 10px
    background-image: url("/images/qr-place.png")
    :deep(.v-btn__content)
      white-space: pre-wrap;
  .logoutBtn
      width 100%
      cursor pointer
      .v-label
        cursor pointer
        opacity 1
        font-size var(--fs-13)
        font-weight 500
        text-transform none
</style>
